<div class="manage-users m-auto mt-5">
  <section class="card shadow-sm-darker mb-4">
    <form #addUser="ngForm" name="addUser" (ngSubmit)="inviteStudent()" class="mb-0">
      <h3 class="card-header mb-0">Invite Student</h3>
      <div class="card-body">
        <div class="fieldset w-100 mb-0">
          <label class="legend" for="email">Enter Email <span class="requiredfield">*</span></label>
          <input type="email" class="text-field" ngModel #email name="email" id="email" required>
        </div>
        
      </div>

      <div class="card-footer">
        <button type="submit" [disabled]="!addUser.form.valid" class="btn">Invite User</button>
      </div>
    </form>
  </section>
</div>
